<template>
  <section class="cr-list" aria-label="Caller records">
    <div class="cr-list__head">
      <div class="cr-list__columns" aria-hidden="true">
        <span>Contact number</span>
        <span>Caller name</span>
        <span>Last called</span>
        <span>Total calls</span>
        <span>Actions</span>
      </div>
    </div>

    <div class="cr-list__scroll">
      <div v-if="loading" class="cr-list__body">
        <div v-for="n in 8" :key="n" class="cr-row cr-row--skeleton" />
      </div>

      <div v-else-if="callers.length" class="cr-list__body" role="list">
        <CallersRow
          v-for="caller in callers"
          :key="caller.id"
          :caller="caller"
          @view="$emit('view', $event)"
          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
        />
      </div>

      <div v-else-if="isSearchActive" class="cr-empty">
        <v-icon icon="mdi-magnify-close" size="40" class="cr-empty__icon" />
        <p class="cr-empty__title">No matching callers</p>
        <p class="cr-empty__subtitle">Try another search or clear the app bar filter.</p>
      </div>

      <div v-else class="cr-empty">
        <v-icon icon="mdi-account-voice" size="40" class="cr-empty__icon" />
        <p class="cr-empty__title">No callers yet</p>
        <p class="cr-empty__subtitle">
          Unique caller records will appear here after calls are received.
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import CallersRow from '@/components/Callers/CallersRow.vue'

defineOptions({ name: 'CallersList' })

defineProps({
  callers: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  isSearchActive: { type: Boolean, default: false },
})

defineEmits(['view', 'edit', 'delete'])
</script>
